var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 168,
    viewBox: "0 0 280 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.25 116.25L162.194 94.1544L184.25 116.25ZM174.417 64.6249C174.417 75.7088 170.014 86.3386 162.177 94.1761C154.339 102.014 143.709 106.417 132.625 106.417C121.542 106.417 110.912 102.014 103.074 94.1761C95.2368 86.3386 90.8337 75.7088 90.8337 64.6249C90.8337 53.5411 95.2368 42.9112 103.074 35.0737C110.912 27.2363 121.542 22.8333 132.625 22.8333C143.709 22.8333 154.339 27.2363 162.177 35.0737C170.014 42.9112 174.417 53.5411 174.417 64.6249V64.6249Z",
    stroke: "#454545",
    strokeWidth: 9.83333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 82C119.916 74.4538 135.199 63.889 149 82",
    stroke: "#454545",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1516_17939)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 143,
    rx: 103.5,
    ry: 12,
    fill: "black",
    fillOpacity: 0.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1516_17939",
    x: 32.5,
    y: 127,
    width: 215,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1516_17939"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono);
export default __webpack_public_path__ + "static/media/Icono.2b0f01d586c9ac3e2bdaadd2668abb34.svg";
export { ForwardRef as ReactComponent };